import { PureComponent } from 'react';
import PropTypes from 'prop-types';

class FormSubmitHandler extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      hasValidationError: false
    };

    this.submitHandler = this.submitHandler.bind(this);
    this.registerComponent = this.registerComponent.bind(this);
    this.resetValidationError = this.resetValidationError.bind(this);
  }

  componentDidMount() {
    this.props.form.addEventListener('submit', this.submitHandler);
  }

  submitHandler(event) {
    const hasValidationError = !this.registeredComponent.isValid(...this.registeredComponentParams);

    if (hasValidationError) {
      event.stopPropagation();
      event.preventDefault();
      this.props.form.setAttribute('data-gdpr-invalid', '');

    } else {
      this.props.form.removeAttribute('data-gdpr-invalid');
    }

    this.setState({ hasValidationError });
  }

  registerComponent(component, ...params) {
    this.registeredComponent = component;
    this.registeredComponentParams = params;
  }

  resetValidationError() {
    setTimeout(() => {
      this.setState({ hasValidationError: false });
    }, 200);
  }

  render() {
    const { props, state } = this;

    // eslint-disable-next-line react/prop-types
    return props.children({
      hasValidationError: state.hasValidationError,
      registerComponent: this.registerComponent,
      resetValidationError: this.resetValidationError
    });
  }
}

FormSubmitHandler.propTypes = {
  form: PropTypes.element.isRequired
};

export default FormSubmitHandler;
